import { TrendingUp, Building2, Rocket, Coins } from "lucide-react";

export const SECTIONS = [
  {
    key: "indian-market",
    label: "Indian Market Scores",
    short: "Indian Market",
    blurb: "KIRA Score research on listed Indian equities — fundamentals, momentum and outlook in one number.",
    icon: TrendingUp,
  },
  {
    key: "unlisted",
    label: "Unlisted Company Scores",
    short: "Unlisted",
    blurb: "Research scores on private and pre-IPO companies before they reach the public markets.",
    icon: Building2,
  },
  {
    key: "upcoming-ipo",
    label: "Upcoming IPO Scores",
    short: "Upcoming IPOs",
    blurb: "KIRA Scores and analysis published ahead of listing day, so you decide before the crowd.",
    icon: Rocket,
  },
  {
    key: "commodity",
    label: "Commodity Scores",
    short: "Commodities",
    blurb: "Score-driven research across key commodities — energy, metals and agriculture.",
    icon: Coins,
  },
];

export const SECTION_MAP = Object.fromEntries(SECTIONS.map((s) => [s.key, s]));
